/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { useState } from 'react';

import { Layout } from '~/components';

import Manual from './Manual';
import { MyData } from './MyData';
import { Package } from './Packages';

import { Container, Content, Sidebar, StudentContent } from './styles';

const Manager = () => {
  const [componentActive, setComponentActive] = useState('myData');

  const sidebarList = [
    {
      value: 'myData',
      title: 'Meus dados',
    },
    {
      value: 'package',
      title: 'Pacotes',
    },
    {
      value: 'manual',
      title: 'Manual',
    },
  ];

  const componentSelected: {
    [key: string]: { title: string; component: JSX.Element };
  } = {
    myData: {
      title: 'Meus dados',
      component: <MyData />,
    },
    package: {
      title: 'Pacotes',
      component: <Package />,
    },
    manual: {
      title: 'Manual',
      component: <Manual />,
    },
  };

  return (
    <Layout title="Configurações">
      <Container>
        <Sidebar>
          <ul>
            {sidebarList.map((item) => (
              <li
                key={item.value}
                onClick={() => setComponentActive(item.value)}
                className={componentActive === item.value ? 'active' : ''}
              >
                <p>{item.title}</p>
              </li>
            ))}
          </ul>
        </Sidebar>

        <Content>
          <StudentContent>
            {componentSelected[componentActive].component}
          </StudentContent>
        </Content>
      </Container>
    </Layout>
  );
};

export default Manager;
